import { Link } from 'react-router-dom';

export interface Crumb {
  label: string;
  to?: string;
}

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="text-sm">
      <ol className="flex flex-wrap items-center gap-1.5 text-foreground-600">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          return (
            <li key={`${item.label}-${index}`} className="flex items-center gap-1.5">
              {item.to && !isLast ? (
                <Link to={item.to} className="hover:text-primary-600 transition-colors">
                  {item.label}
                </Link>
              ) : (
                <span className={isLast ? 'text-foreground-900' : ''}>{item.label}</span>
              )}
              {!isLast && <i className="ri-arrow-right-s-line text-foreground-400"></i>}
            </li>
          );
        })}
      </ol>
    </nav>
  );
}